const roundRect = (context, x, y, width, height, radius) => {
  const safeRadius = Math.min(radius, width / 2, height / 2);
  context.beginPath();
  context.moveTo(x + safeRadius, y);
  context.lineTo(x + width - safeRadius, y);
  context.quadraticCurveTo(x + width, y, x + width, y + safeRadius);
  context.lineTo(x + width, y + height - safeRadius);
  context.quadraticCurveTo(x + width, y + height, x + width - safeRadius, y + height);
  context.lineTo(x + safeRadius, y + height);
  context.quadraticCurveTo(x, y + height, x, y + height - safeRadius);
  context.lineTo(x, y + safeRadius);
  context.quadraticCurveTo(x, y, x + safeRadius, y);
  context.closePath();
};

export default function createPlaceLabelImage() {
  const canvas = document.createElement('canvas');
  canvas.width = 96;
  canvas.height = 48;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Canvas 2D context is unavailable');

  context.clearRect(0, 0, canvas.width, canvas.height);
  context.shadowColor = 'rgba(17, 39, 35, 0.2)';
  context.shadowBlur = 7;
  context.shadowOffsetY = 3;
  context.fillStyle = 'rgba(255, 255, 255, 0.98)';
  roundRect(context, 8, 6, 80, 34, 17);
  context.fill();

  context.shadowColor = 'transparent';
  context.strokeStyle = 'rgba(18, 35, 32, 0.08)';
  context.lineWidth = 1;
  roundRect(context, 8.5, 6.5, 79, 33, 16.5);
  context.stroke();

  return context.getImageData(0, 0, canvas.width, canvas.height);
}
